import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha'; // Importar el componente ReCAPTCHA
import 'bootstrap/dist/css/bootstrap.min.css'; // Importar estilos de Bootstrap
import { Link, useNavigate } from 'react-router-dom';
import BasicLayout from '../layauots/BasicLayout';
import { Alert, AlertTitle, Card, Icon, IconButton } from '@mui/material';
import MDBox from '../controls/MDBox';
import MDTypography from '../controls/MDTypography';
import bgImage from "../../assets/images/bg-sign-up-cover.jpeg";
import logoDataMuni from "../../assets/images/logos/logo_datamuni.png";
import MDInput from '../controls/MDInput';
import { People } from 'react-bootstrap-icons';
import MDButton from '../controls/MDButton';
import API_URL from '../../config';
import { Visibility, VisibilityOff, VpnKey } from '@mui/icons-material';

const Login = ({ handleLogin }) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [captchaValue, setCaptchaValue] = useState('');
  const [grabando, setGrabando] = useState(false);
  const captcha = useRef(null);
  const [mensaje, setMensaje] = useState("");

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
    },
    passwordInput: {
      flex: 1,
    },
    passwordIcon: {
      position: 'absolute',
      right: 0,
      cursor: 'pointer',
      zIndex: 1, // Asegura que el icono esté en la capa superior
      height: 'auto', // Ajusta la altura según sea necesario
    },
    pwIcon: {
   
      height: 'auto', // Ajusta la altura según sea necesario
    },
  };
  
  localStorage.setItem('isLoggedIn', 'false');

  // useEffect(() => {
  //   // Establece el valor de 'isLoggedIn' en false al cargar la página de inicio

  //   console.log('wwwwwwwwwwwwwww');
  // }, []);
  //const [userPermissions, setUserPermissions] = useState({}); // Datos de permisos del usuario
  const [formData, setFormData] = useState({

    // Inicializa los campos del formulario
    email: "",
    pass: "",

  });

  const handleInputChange = (event) => {
    // Maneja los cambios en los campos del formulario

    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  
  const handleCuentaXToken = (value) => {
 
      setCaptchaValue(true);
      localStorage.setItem('isRegister', 'false');
      localStorage.setItem('isLoggedIn', 'false');
      localStorage.setItem('isActivarCuenta', 'true');
      localStorage.setItem('isForgotPassword', 'false');
    
  };
  const handleChangePassword = (value) => {
 
      setCaptchaValue(true);
      localStorage.setItem('isRegister', 'false');
      localStorage.setItem('isLoggedIn', 'false');
      localStorage.setItem('isActivarCuenta', 'false');
      localStorage.setItem('isForgotPassword', 'true');
    
  };
  const handleCaptchaChange = (value) => {
    if (captcha.current.getValue()) {

      setCaptchaValue(true);
    }
  };
  const handleRegistrarme = () => {
    localStorage.setItem('isRegister', 'true');
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.setItem('isActivarCuenta', 'false');
    localStorage.setItem('isForgotPassword', 'false');
  };

  const handleSubmit = async (data) => {
    setMensaje("");
    setGrabando(true);
    if (captcha.current.getValue()) {
      setCaptchaValue(true);

    } else {
      setGrabando(false);
      setCaptchaValue(false);
      setIsLoggedIn(false);
      setMensaje("Por favor acepta el captcha.");
      return;
    }

    //Primero voy a la base si el login es correcto vuelvo y ejecuto esa funcion que actualizara un estado en App.js

    try {
      const res = await fetch(API_URL + "/LoginJWT ", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const resData = await res.json();
      console.log("Datos de la respuesta:", resData);
      
   
      if (resData.isSuccess) {
        localStorage.setItem('token', resData.value.token);
        localStorage.setItem('userlogueado', resData.value.email);
        localStorage.setItem('nameuserlogueado', resData.value.nombre);
        localStorage.setItem('iduserlogueado', resData.value.idUsuario);
        localStorage.setItem('idPerfil', resData.value.idPerfil);
        localStorage.setItem('nombrePerfil', resData.value.nombrePerfil ?? 'Sin perfil');
        //Aca ANALIZAR SI LoginCambiarClave = true  DEBO IR A LA PAGINA DE CAMBIAR CONTRASEÑA
        if (resData.value.loginCambiarClave === true) {
          setMensaje("cambiarClave");
          setGrabando(false);
          return;
        }
        // Manejar respuesta exitosa
        setMensaje("¡Usuario Logueado exitosamente!");

        handleLogin();
      } else {
        // Manejar errores si la respuesta no es exitosa
        setMensaje(resData.error);
        setGrabando(false);
        setIsLoggedIn(false);
      }
    }
    catch (error) {
      setMensaje("Error en la solicitud: el usuario no pudo ser identificado");
      setGrabando(false);
      setIsLoggedIn(false);
    }

  };
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Bienvenido!!
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Inicie sesión con su usuario y contraseña
          </MDTypography>
        </MDBox>
        <MDBox pt={3} pb={3} px={3}>
          <MDBox display="flex" justifyContent="center" mb={2}>
            <MDBox component="img" src={logoDataMuni} alt="Data Muni" sx={{ height: "7rem", maxWidth: "100%" }} />
          </MDBox>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                name="email"
                label="Usuario"
                variant="standard"
                value={formData.email}
                onChange={handleInputChange}
                fullWidth
              />
            </MDBox>
            
            <MDBox mb={2} style={styles.container}>
              <MDInput
                 type={showPassword ? 'text' : 'password'}
                name="pass"
                label="Contraseña"
                variant="standard"
                value={formData.pass}
                onChange={handleInputChange}
                fullWidth
                style={styles.passwordInput}
              />
               <IconButton  style={styles.passwordIcon} onClick={handleTogglePasswordVisibility}>
                {showPassword ? (
                  <Icon style={styles.passwordIcon}>
                    <Visibility />
                  </Icon>
                ) : (
                  <Icon style={styles.passwordIcon}>
                    <VisibilityOff />
                  </Icon>
                )}
              </IconButton>
            </MDBox>
            <MDBox mb={2}>
              <ReCAPTCHA
                ref={captcha}
                sitekey="6Lfd3e0rAAAAAC43_dhLkc5m9l9nNmvANzo-ZvwD"
                onChange={handleCaptchaChange}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                onClick={() => {
                  handleSubmit();
                }}
                variant="gradient"
                color="info"
                endIcon={<People />}
                fullWidth
                disabled={grabando}
              >
                Iniciar
              </MDButton>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                ¿No tienes una cuenta? Regístrate {" "}
                <MDTypography
                  component={Link}
                  to="/Registrarme"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                  onClick={() => {
                    handleRegistrarme();
                  }}
                >
                  aquí
                </MDTypography>
              </MDTypography>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                ¿Ya te Registraste y Necesitas activar tu cuenta?  {" "}
                <MDTypography
                  component={Link}
                  to="/ConfirmarCuentaXToken"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                onClick={() => {
                  handleCuentaXToken();
                }}
                >
                  Activa tu cuenta
                </MDTypography>
              </MDTypography>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">

                <MDTypography
                  component={Link}
                  to="/RecuperarPass"
                  variant="button"
                  color="secondary"
                  fontWeight="medium"
                  textGradient
                  onClick={() => {
                    handleChangePassword();
                  }}
                >
                  ¿Olvide mi contraseña? {" "}
                </MDTypography>
              </MDTypography>
            </MDBox>
            {/* <MDBox mt={4} mb={1}>
              <MDProgress color="success"
                loading="true"
                value={showprogrees === 0 ? progress : 0}
                display={'true'}
                variant="contained"></MDProgress>

            </MDBox> */}

            {mensaje === 'cambiarClave' && (
              <Alert severity="warning" icon={<VpnKey />}>
                <AlertTitle>Contraseña Expirada</AlertTitle>
                Debe cambiar su contraseña antes de continuar.{" "}
                <MDTypography
                  component={Link}
                  to="/CambiarContrasenia"
                  variant="button"
                  color="warning"
                  fontWeight="bold"
                  textGradient
                >
                  Haga clic aquí para cambiar su contraseña
                </MDTypography>
              </Alert>
            )}

            {mensaje !== '' && mensaje !== 'cambiarClave' && (
              <Alert severity={"error"}>
                <AlertTitle>{"Error"}</AlertTitle>
                {mensaje}
              </Alert>
            )}

          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>

  );
};

export default Login;